<template>
    <div class="edit-duration">
        <cic-textbox
            :enabled="enabled"
            :value="text"
            :int-only="true"
            :maxlength="16"
            @input="(val) => updateValue(val, units)"
        />
        <cic-select
            :enabled="enabled"
            :value="units"
            :options="[
                { value: 0, label: $t('Minutes') },
                { value: 1, label: $t('Hours') },
                { value: 2, label: $t('Days') },
                { value: 3, label: $t('Years') },
            ]"
            @input="(val) => updateValue(text, val)"
        />
    </div>
</template>

<script>
    import CicSelect from '@/components/inputs/CicSelect';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'EditDuration',
        components: {
            CicSelect,
            CicTextbox,
        },
        props: {
            enabled: {
                type: Boolean,
                default: false,
            },
            value: {
                type: Number,
                required: true,
            },
        },
        emits: ['input'],
        computed: {
            convert() {
                return this.value >= 3600 && this.value % 3600 === 0;
            },

            text() {
                let value = this.value / 60;
                if (this.convert) {
                    value = value / 60;

                    if (this.units >= 2) {
                        value = value / 24;
                    }

                    if (this.units === 3) {
                        value = value / 365;
                    }
                }

                return value;
            },

            units() {
                if (this.convert) {
                    const hours = this.value / 3600;
                    if (hours % 24 === 0) {
                        const days = hours / 24;
                        if (days % 365 === 0) {
                            return 3;
                        }

                        return 2;
                    }

                    return 1;
                }

                return 0;
            },
        },
        methods: {
            updateValue(val, units) {
                this.$emit('input', val * 60 * (units >= 1 ? 60 : 1) * (units >= 2 ? 24 : 1) * (units === 3 ? 365 : 1));
            },
        },
    };
</script>
